import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { Pagination } from '../../interfaces/Pagination';
import { Gallery } from '../../interfaces/Gallery/Gallery';
import { getGalleries } from '../../api/Gallery';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { GalleriesTable } from './GalleriesTable';

export const GalleriesPage = () => {
  const navigate = useNavigate();

  const [galleries, setGalleries] = useState<PaginatedResponse<Gallery>>({
    data: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);

  const refreshGalleries = () => {
    setLoading(true);
    getGalleries(pagination)
      .then((g) => setGalleries(g))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshGalleries();
  }, [pagination]);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Galeriler
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/visual/galleries/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Galeri
      </Button>
      <GalleriesTable
        galleries={galleries.data}
        totalCount={galleries.totalCount}
        pagination={pagination}
        onPagination={setPagination}
      />
    </Box>
  );
};
